import passwordUpdate from './password-update'

export default passwordUpdate
